/**
 * proteinSelection_Generic__UserSelectionData.ts
 *
 *  Protein Selection:  Overlay for user to select proteins
 *
 *  User Selection Data:  List of User Selections of proteins
 *
 *
 */


export class ProteinSelection_Generic__UserSelectionData_Root {

    selected_proteinSequenceVersionId: Set<number>
}
